/** 账号协助：坐席申请临时登录客户的代账账号排查问题，客户同意后最长 8 小时。 */
export type AccountAssistStatus = 'active' | 'ended' | 'expired' | 'pending' | 'rejected' | 'revoked';

export interface AccountAssist {
  adminDirect?: boolean;
  id: string;
  conversationId: string;
  status: AccountAssistStatus;
  staffName: string;
  customerName: string;
  requestedAt: string;
  /** 申请超过这个时间没处理就失效。 */
  requestExpiresAt: string;
  acceptedAt?: string;
  /** 授权到期时间（同意后才有）。 */
  expiresAt?: string;
  /** 坐席第一次进入客户账号的时间。 */
  openedAt?: string;
  endedAt?: string;
  /** customer | staff | system */
  endedBy?: string;
  /** 员工本人能否进入、结束；客户侧恒为 false。 */
  canOperate: boolean;
}

/** 客户同意、拒绝、取消授权；坐席结束（含撤回申请）。 */
export type AccountAssistAction = 'accept' | 'end' | 'reject' | 'revoke';

export const isAccountAssistOpen = (assist: AccountAssist | null | undefined): assist is AccountAssist =>
  assist?.status === 'pending' || assist?.status === 'active';

/** 北京时间 HH:mm；不是今天时带月日。 */
export function assistDeadlineText(iso: string | undefined, now = new Date()): string {
  if (!iso) return '';
  const at = new Date(iso);
  if (Number.isNaN(at.getTime())) return '';
  const shift = (d: Date) => new Date(d.getTime() + 8 * 3600 * 1000);
  const a = shift(at);
  const n = shift(now);
  const hm = `${String(a.getUTCHours()).padStart(2, '0')}:${String(a.getUTCMinutes()).padStart(2, '0')}`;
  const sameDay = a.getUTCFullYear() === n.getUTCFullYear() && a.getUTCMonth() === n.getUTCMonth() && a.getUTCDate() === n.getUTCDate();
  return sameDay ? hm : `${a.getUTCMonth() + 1}月${a.getUTCDate()}日 ${hm}`;
}
